import React from "react";
import { motion } from "framer-motion";
import HeroHexagon from "../HeroHexagon";

const Terms = () => {
  const textAnimate = {
    hidden: { opacity: 0, y: -100 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        ease: "easeInOut",
        duration: 0.8,
      },
    },
  };
  return (
    <>
      <div className="hero is-flex is-center dir-column ">
        <div className="container">
          <div className="hero-content clr-white">
            <motion.div
              className="content"
              initial="hidden"
              whileInView={"visible"}
              viewport={{ once: false, amount: 0.1 }}
              transition={{ staggerChildren: 1 }}
            >
              <motion.h5 className="fw-600 " variants={textAnimate}>
                <span className="line-shape pb-12 line-shape_left">
                  Legal
                </span>
              </motion.h5>

              <motion.h1 className="my-32 fs-h3" variants={textAnimate}>
                Terms of <span className="italic">Service</span>
              </motion.h1>
              <motion.p className="fw-400" variants={textAnimate}>
                Last updated: March 2026
              </motion.p>
            </motion.div>
            <HeroHexagon />
          </div>
        </div>
      </div>
      <section className="about">
        <div className="container">
          <div className="about-content">
            <h5 className="clr-secondary mb-16">1. Overview</h5>
            <p className="mb-32">
              9Feathers ("we", "us", "our") is a business-to-business (B2B) software development company. We provide custom software development, testing, and technology consulting services to businesses and organizations under individually negotiated contracts.
            </p>

            <h5 className="clr-secondary mb-16">2. Nature of Services</h5>
            <p className="mb-32">
              All services are provided under signed agreements between 9Feathers and the client. We do not sell products, subscriptions, or digital goods through this website. This website serves as an informational resource about our company and services.
            </p>

            <h5 className="clr-secondary mb-16">3. Payments and Billing</h5>
            <p className="mb-32">
              Payments are invoiced based on milestones agreed upon in the signed contract. No automated payments, recurring charges, or online transactions are processed through this website. All billing is handled directly between 9Feathers and the client per the terms of their individual agreement.
            </p>

            <h5 className="clr-secondary mb-16">4. Project Engagement</h5>
            <p className="mb-32">
              Engagement with 9Feathers begins only after both parties sign a service agreement that outlines the project scope, deliverables, timeline, and payment terms. No work is commenced without a written agreement in place.
            </p>

            <h5 className="clr-secondary mb-16">5. Intellectual Property</h5>
            <p className="mb-32">
              Ownership of deliverables is determined by the terms of each individual service agreement. Unless otherwise specified in the contract, all intellectual property created during the project is transferred to the client upon full payment.
            </p>

            <h5 className="clr-secondary mb-16">6. Limitation of Liability</h5>
            <p className="mb-32">
              9Feathers' liability is limited to the total amount paid by the client under the applicable service agreement. We are not liable for indirect, incidental, or consequential damages arising from the use of our services.
            </p>

            <h5 className="clr-secondary mb-16">7. Governing Law</h5>
            <p className="mb-32">
              These terms are governed by the laws of the State of Delaware, United States.
            </p>

            <h5 className="clr-secondary mb-16">8. Contact</h5>
            <p>
              For questions about these terms, contact us at{" "}
              <a href="mailto:info@9feathers.app" className="clr-primary">info@9feathers.app</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
